import Router from './Router'

export default Router
// eslint-disable-next-line import/export
export * from './Router'
export * from './useHistory'
